<template>
    <section>
        <div class="row">
            <div class="col">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item h3 font-weight-bold mb-0">
                            <router-link v-bind:to="{ name: 'branch/index' }">
                                Cabang
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-bind:to="{ name: 'branch/view', params: {id: branch.id} }">
                                {{ branch.name }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active font-weight-medium" aria-current="page">
                            Edit Program
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-sm-8">
                <div class="card shadow-sm mb-4 border-0">
                    <div class="card-header background-primary">
                        <div class="row">
                            <div class="col">
                                <span class="h4 font-weight-medium text-white mb-0">
                                    Program
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <form v-on:submit.prevent="save">
                            <div class="row">
                                <div class="col-4 align-self-end">
                                    <div class="form-group">
                                        <label class="font-weight-medium">Pilih Program</label>
                                        <input class="form-control form-control-sm" disabled="disabled" v-bind:value="program.grade ? program.grade.name : ''" />
                                    </div>
                                </div>
                                <div class="col-8 align-self-end">
                                    <div class="form-group">
                                        <label class="font-weight-medium required">Tipe Kelas</label>
                                        <multiselect v-model="form.programType" v-bind:options="types" v-bind:taggable="true" v-bind:allow-empty="false" tag-placeholder="" select-label="" v-on:tag="addTag" placeholder="Tipe Kelas" class="form-control form-control-sm" required>
                                        </multiselect>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12" v-for="(pattern, patternIndex) in form.patterns">
                                    <div class="row">
                                        <div class="col">
                                            <h4 class="text-danger font-weight-bold mb-1">
                                                Pola {{ patternIndex + 1 }}
                                                <a href="#" v-if="form.patterns.length > 1" v-on:click.prevent="removePattern(patternIndex)">
                                                    <i class="fa fa-times text-danger"></i>
                                                </a>
                                            </h4>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12 col-md-4">
                                            <label class="font-weight-medium required mb-1">Hari Pola</label>
                                        </div>
                                        <div class="col-md-8 d-none d-md-block">
                                            <label class="font-weight-medium required mb-1">Sesi Pola</label>
                                        </div>
                                    </div>
                                    <div class="row" v-for="(period, index) in pattern.periods">
                                        <div class="col-12">
                                            <div class="row">
                                                <div class="col-12 col-md-4">
                                                    <div class="form-group">
                                                        <select v-model="period.day" class="form-control form-control-sm" required>
                                                            <option disabled value="">Pilih Hari</option>
                                                            <option v-for="n in 7" v-bind:value="n">{{ $moment.weekdays(n) }}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="col-12 col-md-8">
                                                    <div class="row">
                                                        <div class="col pr-1">
                                                            <div class="form-group">
                                                                <datetimepicker v-model="period.start" v-bind:config="datetimepickerOption" placeholder="Waktu Mulai" class="form-control-sm" required></datetimepicker>
                                                            </div>
                                                        </div>
                                                        <div class="col-auto px-1 text-center">
                                                            <i class="fa fa-minus"></i>
                                                        </div>
                                                        <div class="col px-1">
                                                            <div class="form-group">
                                                                <datetimepicker v-model="period.end" v-bind:config="datetimepickerOption" placeholder="Waktu Selesai" class="form-control-sm" required></datetimepicker>
                                                            </div>
                                                        </div>
                                                        <div class="col px-1">
                                                            <div class="form-group">
                                                                <input v-model="period.slots" type="number" class="form-control form-control-sm" placeholder="Jumlah Slot" required />
                                                            </div>
                                                        </div>
                                                        <div class="col-auto pl-1 text-center">
                                                            <a href="#" v-if="pattern.periods.length > 1" v-on:click.prevent="removeTime(patternIndex, index)">
                                                                <i class="fa fa-times text-danger"></i>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <hr class="d-block d-md-none mt-0" />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12 mb-4">
                                            <button class="btn btn-link btn-sm px-0" type="button" v-on:click="addTime(patternIndex)">
                                                Tambah Hari Pola +
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12 mb-4" v-for="(intensive, intensiveIndex) in form.intensiveSchedules">
                                    <div class="row">
                                        <div class="col">
                                            <h4 class="text-danger font-weight-bold mb-1">
                                                Sesi Intensif  {{ intensiveIndex + 1 }}
                                                <a href="#" v-on:click.prevent="removeIntensive(intensiveIndex)">
                                                    <i class="fa fa-times text-danger"></i>
                                                </a>
                                            </h4>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-5">
                                            <label class="font-weight-medium required mb-1">Nama Sesi</label>
                                            <div class="form-group">
                                                <input v-model="form.intensiveSchedules[intensiveIndex].name" class="form-control form-control-sm" placeholder="Nama Kelas" required />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 text-right mb-4">
                                    <button class="btn btn-outline-danger px-5 btn-sm mr-2" type="button" v-on:click="addIntensive">
                                        Tambah Sesi Intesif +
                                    </button>
                                    <button class="btn btn-danger px-5 btn-sm" type="button" v-on:click="addPattern">
                                        Tambah Pola +
                                    </button>
                                </div>
                            </div>
                            <div class="pt-3 text-center">
                                <button type="submit" class="btn btn-danger btn-sm px-5 mb-2">
                                    Save
                                </button>
                                <router-link v-bind:to="{ name: 'branch/view', params: {id: branch.id} }" exact class="btn btn-outline-danger btn-sm px-5 ml-3 mb-2">
                                    Cancel
                                </router-link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import Datetimepicker from 'vue-bootstrap-datetimepicker';

    export default {
        name: "BranchProgramEdit",
        components: {
            Multiselect,
            Datetimepicker
        },
        data() {
            return {
                form: {
                    programType: '',
                    patterns: [],
                    intensiveSchedules: []
                },
                branch: {},
                program: {},
                types: [],
                days: [],
                datetimepickerOption: {format: 'HH:mm:ss', useCurrent: 'day', locale: 'id', showClear: true}
            };
        },
        methods: {
            addTag(newTag) {
                this.types.push(newTag);
                this.form.programType = newTag;
            },
            addPattern() {
                var total = this.form.patterns.push({periods: []});
                this.addTime(total - 1);
            },
            addIntensive() {
                this.form.intensiveSchedules.push({name: ''});
            },
            addTime(patternIndex) {
                var times = this.form.patterns[patternIndex];
                if (typeof times !== typeof undefined) {
                    times.periods.push({
                        day: '',
                        start: '',
                        end: '',
                        slots: ''
                    });
                }
            },
            removePattern(index) {
                var pattern = this.form.patterns[index];
                if (pattern.id) {
                    if (confirm('Hapus pola? Pola tidak dapat dikembalikan.')) {
                        this.axios.post(process.env.API_URL + '/pattern/delete/' + pattern.id).then(response => {
                            if (response.data.status) {
                                this.$toastr('success', response.data.message, 'Success');
                                this.form.patterns.splice(index, 1);
                            } else {
                                this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                            }
                        });
                    }
                } else {
                    this.form.patterns.splice(index, 1);
                }
            },
            removeIntensive(index) {
                var intensive = this.form.intensiveSchedules[index];
                if (intensive.id) {
                    if (confirm('Hapus sesi intensif? Sesi intensif tidak dapat dikembalikan.')) {
                        this.axios.post(process.env.API_URL + '/intensive-schedule/delete/' + intensive.id).then(response => {
                            if (response.data.status) {
                                this.$toastr('success', response.data.message, 'Success');
                                this.form.intensiveSchedules.splice(index, 1);
                            } else {
                                this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                            }
                        });
                    }
                } else {
                    this.form.intensiveSchedules.splice(index, 1);
                }
            },
            removeTime(patternIndex, index) {
                var period = this.form.patterns[patternIndex].periods[index];
                if (period.id) {
                    if (confirm('Hapus periode? Periode tidak dapat dikembalikan')) {
                        this.axios.post(process.env.API_URL + '/period/delete/' + period.id).then(response => {
                            if (response.data.status) {
                                this.$toastr('success', response.data.message, 'Success');
                                this.form.patterns[patternIndex].periods.splice(index, 1);
                            } else {
                                this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                            }
                        });
                    }
                } else {
                    this.form.patterns[patternIndex].periods.splice(index, 1);
                }
            },
            save() {
                this.axios.post(process.env.API_URL + '/branch-program/update/' + this.$route.params.programID, this.form).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.$router.push({name: 'branch/view', params: {id: this.branch.id}});
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            preview(event) {
                var input = event.currentTarget;
                if (input.files && input.files[0]) {
                    this.image = input.files[0];
                    var reader = new FileReader();
                    reader.onload = function (event) {
                        this.imagePreview = event.target.result;
                    }.bind(this);
                    reader.readAsDataURL(input.files[0]);
                }
            }
        },
        created() {
            this.axios.all([
                this.axios.get(process.env.API_URL + '/program-type'),
                this.axios.get(process.env.API_URL + '/branch/' + this.$route.params.id)
            ]).then(this.axios.spread(function (responseProgram, responseBranch) {
                this.types = responseProgram.data.data.map(function (item) {
                    return item.name;
                });
                this.branch = responseBranch.data.data;

                var program = this.branch.branchPrograms.find(branchProgram => {
                    return branchProgram.id === parseInt(this.$route.params.programID);
                });
                if (typeof program === typeof undefined) {
                    this.$router.replace({name: 'error', params: {code: 404, message: 'Program not found'}});
                }
                this.program = program;
                this.form.intensiveSchedules = program.intensiveSchedules;
                this.form.programType = program.programType.name;
                this.form.patterns = program.patterns;

                document.title = this.branch.name + ' - Edit Program - ' + process.env.APP_NAME;
            }.bind(this))).catch((error) => {
                this.$router.replace({name: 'error', params: {code: error.response.status, message: error.response.statusText}});
            });
        }
    };
</script>

<style scoped>
    img:not([src]), img[src=""]{
        display: none;
    }
</style>


// WEBPACK FOOTER //
// src/components/branch/program/Edit.vue